export const FlightLeg = `
segments {
    airline {
        name
        imageName
        code
    }
    duration
    departureAirport {
        airportCode
        title
    }
    arrivalAirport {
        airportCode
        title
    }
    departureDateTime {
        date(format: $departureDateFormat)
        time(format: $timeFormat)
    }
    arrivalDateTime {
        date(format: $departureDateFormat)
        time(format: $timeFormat)
    }
    flightNumber
    departureDateFormatted(format: $departureDateFormat)
    arrivalDateFormatted(format: $departureDateFormat)
    layoverTime
    dayDifference
    operatingAirline {
        name
        code
        imageName
    }
    cabinClass
}
airlines {
    name
    code
    imageName
}
duration
departureAirport {
    airportCode
    title
}
arrivalAirport {
    airportCode
    title
}
departureDateTime {
    date(format: $departureDateFormat)
    time(format: $timeFormat)
}
arrivalDateTime {
    date(format: $departureDateFormat)
    time(format: $timeFormat)
}
stops
totalBagsIncluded
dayDifference
savingsForPromotedFlights

`;
